<template>
  <div class="user-select-wrapper">
    <v-select
      multiple
      append-to-body
      :options="options"
      label="label"
      v-model="selected"
      :placeholder="placeholder"
    />
    <input
      v-for="user in selected"
      :key="user.id"
      type="hidden"
      :name="attribute_name"
      :value="user.id"
    >
  </div>
</template>

<script setup>
import { ref } from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const props = defineProps({
  // ユーザー選択肢のJSON文字列（[{id, name, email}, ...]）。Blade側でjson_encodeして渡す
  options: {
    type: String,
    default: '[]',
  },
  // 選択値を送出する hidden input の name（例: "user_ids[]"）。呼び出し側が完全な形で指定する
  attribute_name: {
    type: String,
    default: 'user_ids[]',
  },
  placeholder: {
    type: String,
    default: '',
  },
  // バリデーションエラー再表示用の初期選択ID（JSON配列文字列）
  default_ids: {
    type: String,
    default: '[]',
  },
});

const parseJsonArray = (value) => {
  try {
    const parsed = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('UserSelectComponent: failed to parse JSON prop', error);
    return [];
  }
};

// 表示ラベルは現行 <select> の option 表示（「氏名（メールアドレス）」）に合わせる
const options = ref(
  parseJsonArray(props.options).map((user) => ({
    ...user,
    label: `${user.name}（${user.email}）`,
  }))
);

const defaultIds = parseJsonArray(props.default_ids).map((id) => Number(id));

const selected = ref(
  options.value.filter((user) => defaultIds.includes(Number(user.id)))
);
</script>
